import type { DeliveryReconCellRendererParams, DeliveryReconOverviewRow } from '../types'
import { GraviButton, MaterialIcon } from '@gravitate-js/excalibrr'
import { Tooltip } from 'antd'
import { useState } from 'react'

export function ActionsCellRenderer({
  params,
  action,
}: {
  params: DeliveryReconCellRendererParams
  action: ((row: DeliveryReconOverviewRow[], approve: boolean) => Promise<void>) | undefined
}) {
  const { details } = params.data ?? {}
  const [loading, setLoading] = useState(false)
  const canApprove = details?.some((d) => d.type === 'bol')
  const isApproved = params.data?.status === 'approved'

  async function onClick(row: DeliveryReconOverviewRow | undefined, approve: boolean) {
    if (!row) return
    try {
      setLoading(true)
      await action?.([row], approve)
    } catch (error) {
      console.error('Error performing action:', error)
    } finally {
      setLoading(false)
    }
  }

  if (!canApprove) return null
  return (
    <Tooltip title={isApproved ? 'Unapprove' : 'Approve'}>
      {isApproved ? (
        <GraviButton
          appearance='outline'
          loading={loading}
          icon={<MaterialIcon style={{ paddingTop: '2px' }} icon='rotate_left' size={16} />}
          onClick={() => onClick(params.data, false)}
        />
      ) : (
        <GraviButton
          appearance='solid'
          loading={loading}
          color='green'
          icon={<MaterialIcon style={{ paddingTop: '2px' }} icon='check_circle' size={18} />}
          onClick={() => onClick(params.data, true)}
        />
      )}
    </Tooltip>
  )
}
